/* eslint-disable react/prop-types */
import {
  Button,
  Card,
  CardActions,
  CardContent,
  FormGroup,
  Grid,
  IconButton,
  LinearProgress,
  Snackbar,
  SnackbarContent,
  Tooltip,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import * as React from "react";
import { useEffect, useState } from "react";
import Rest from "src/services/Rest";
import { getError } from "src/services/ErrorService";
import SelectSingle from "src/component/selectsingle/SelectSingle";
import "./ProductGroupingNew.scss";
import TableProductRelation from "./TableProductRelation";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

export interface IProductGroupingNewProps {
  itemSelected: any;
  closeForm: (msg?: string) => void;
}

interface ISkuPrincipal {
  valor: null;
  label: "";
}

interface ISkuRelacionado {
  valor: null;
  label: "";
}

function ProductGroupingNewForm(props: IProductGroupingNewProps) {
  const {closeForm, itemSelected} = props
  const [listSku, setListSku] = useState([]);
  const [listRelacionados, setListRelacionados] = useState<any>([]);
  const [listRelationOptions, setListRelationOptions] = useState([]);
  const [skuPrincipal, setSkuPrincipal] = useState<ISkuPrincipal | null>(null);
  const [skuRelacionado, setSkuRelacionado] = useState<ISkuRelacionado | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  
  const [alert, setStateAlert] = useState({
    message: "",
    open: false,
    type: "",
  });

  const openAlert = (msg: string, tipo: string) => {
    const item = { message: msg, type: tipo, open: true };
    setStateAlert(item);
  };

  const closeAlert = () => {
    const item = { message: "", type: "", open: false };
    setStateAlert(item);
  };

  const handleSkuPrincipal = (ev: any) => {
    setSkuPrincipal(ev);
  };

  const handleRelationOptions = (ev: any) => {
    setSkuRelacionado(ev);
  };

  const columns = [
    {
      render: (item: any) => <span>{item.sku_principal_desc}</span>,
      title: "Sku Principal",
    },
    {
      render: (item: any) => <span>{item.sku_secundario_desc}</span>,
      title: "Sku Relacionado"
    },
    {
      render: (item: any) => (
        <>
          <IconButton
            component={"span"}
            onClick={() => excluir(item)}
            className="filter-dialog-close"
            color="secondary"
          >
            <Tooltip title="Remover">
              <DeleteIcon />
            </Tooltip>
          </IconButton>
        </>
      ),
      title: "Remover",
    },
  ]

  const searchSku = async (filtro: any) => {
    setLoading(true);
    let endPoint = `product-group-new/relacionado`;
    
    if ( itemSelected && itemSelected.id) {
      endPoint += `?id=${itemSelected.id}`;
    }

    if (!!filtro.sku_principal && filtro.sku_principal !== "") {
      endPoint += endPoint.includes("?") ? `&sku_principal=${filtro.sku_principal}` : `?sku_principal=${filtro.sku_principal}`;
    }
    const isTerm = !!filtro.term && filtro.term !== "";
    if (isTerm) {
      endPoint += endPoint.includes("?") ? `&term=${filtro.term}` : `?term=${filtro.term}`;
    }

    await Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (result && result.error) {
          const erro = getError(result.error);
          openAlert(erro.message, "erro");
        } else {
          setListSku(result);
          if( itemSelected && itemSelected.id && !isTerm){
            setSkuPrincipal(result[0])
          }
          setLoading(false);
      }});
  };

  const changeSkuPrincipal = (ev: any) => {
    const filtro = {
      term: ev ? ev : null
    }
    setListSku([])
    searchSku(filtro)
  }

  const changeSkuRelacionado = (ev: any) => {
    if(skuPrincipal !== null){
      setListRelationOptions([])
      searchOptionsRelation(skuPrincipal, ev)
    }
  }

  const searchRelacionados = async (id: any) => {
    setLoading(true);
    const endPoint = `product-group-new/relacionados/${id}`;

    await Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (result && result.error) {
          const erro = getError(result.error);
          openAlert(erro.message, "erro");
        } else {
          setListRelacionados(result);
          setLoading(false);
      }});
  };

  const searchOptionsRelation = async (sku: any, term: any) => {
    setLoading(true);
    let endPoint = `product-group-new/options?sku_principal=${sku.valor}`;

    if(term !== null){
      endPoint += `&term=${term}`;
    }

    await Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (result && result.error) {
          const erro = getError(result.error);
          openAlert(erro.message, "erro");
        } else {
          setListRelationOptions(result);
          setLoading(false);
      }});
  };

  const excluir = (item: any) => {
    if (!!item && !!item.sku_secundario) {
      const list = listRelacionados.filter((v:any) => item.sku_secundario !== v.sku_secundario)
      setListRelacionados(list)
    }
  }

  const adicionar = () => {
    setLoading(true)
    const sku = skuRelacionado && skuRelacionado.valor ? skuRelacionado.valor : null
    const indExists = listRelacionados.filter((v:any) => sku !== null && sku === v.sku_secundario).length > 0
    if(indExists){
      openAlert("Sku selecionado já está relacionado: " + sku,"erro");
      setLoading(false)
      return
    }
    const item = {
      sku_principal: skuPrincipal && skuPrincipal.valor ? skuPrincipal.valor : null,
      sku_principal_desc: skuPrincipal && skuPrincipal.label ? skuPrincipal.label : null,
      sku_secundario: sku,
      sku_secundario_desc: skuRelacionado && skuRelacionado.label ? skuRelacionado.label : null
    } 
    if (item && item.sku_secundario !== null && item.sku_principal !== null){
      const list = Object.assign(listRelacionados, [])
      list.push(item)
      setListRelacionados(list)
      setSkuRelacionado(null)
      setLoading(false)
    }
  }

  const saveRelation = async () => {
    try {
      if (!skuPrincipal || !skuPrincipal.valor) {
        return openAlert("Obrigatório selecionar Sku principal", "erro")
      }
      if (listRelacionados.length < 1) {
        return openAlert("Obrigatório adicionar Sku relacionado", "erro")
      }
      const params = {
        id: itemSelected && itemSelected.id ? itemSelected.id : null,
        sku_principal: skuPrincipal.valor,
        sku_secundario: listRelacionados,
      }
      setLoading(true);
      const response = await Rest.PostBody("product-group-new", params);
      const msg =  indSelecionado() ? "Novas alterações salvas com sucesso." : "Novo relacionamento salvo com sucesso." 
      if (response) {  
        setLoading(false)
        setSkuPrincipal(null)
        closeForm(msg)
      }
    } catch (error) {
    const erro = getError(error);
      openAlert(erro.message, "erro");
      setLoading(false);
    }  
  }

  const indSelecionado = () => {
    return itemSelected && itemSelected.id
  }

  const indSkuRelacionado = () => {
    return skuRelacionado && skuRelacionado.valor
  }

  useEffect(() => {
    if(skuPrincipal !== null && skuPrincipal !== undefined){
      searchOptionsRelation(skuPrincipal, null)
    } else {
      setListRelationOptions([])
      setSkuRelacionado(null)
    }
  }, [skuPrincipal]);

  useEffect(() => {
    searchSku({})
    if(itemSelected && itemSelected.id){
      searchRelacionados(itemSelected.id)
    }
  }, []);

  return (
    <Grid container={true} direction="column" spacing={16}>
      <Grid item={true} xs={12}>
        <Card>
          <CardContent>
            <Snackbar
              anchorOrigin={{
                horizontal: "center",
                vertical: "center",
              }}
              open={alert.open}
              autoHideDuration={4000}
              onClose={closeAlert}
            >
              <SnackbarContent
                message={alert.message}
                style={styles[alert.type]}
              />
            </Snackbar>
            {loading && <LinearProgress />}
            <form>
              <FormGroup row={true}>
                <Grid container={true} spacing={8} alignItems="flex-end">
                  <Grid item={true} xs={4} style={{ marginBottom: "48px", marginTop: "30px" }}>
                    <div className="select-associate">
                    <SelectSingle 
                      inputChange={changeSkuPrincipal}
                      value={skuPrincipal}
                      onChange={handleSkuPrincipal}
                      options={listSku}
                      placeholder={"Sku Principal"}
                    />
                    </div>
                  </Grid>
                </Grid>
              </FormGroup>
              <FormGroup row={true}>
                <Grid container={true} spacing={8} alignItems="flex-end">
                  <Grid item={true} xs={8} style={{ marginBottom: "48px", marginTop:"30px" }}>
                    <div className="select-associate">
                    <SelectSingle 
                      inputChange={changeSkuRelacionado}
                      value={skuRelacionado}
                      onChange={handleRelationOptions}
                      options={listRelationOptions}
                      placeholder={"Sku Relacionado"}
                    />
                    </div>
                  </Grid>
                  <Grid item={true} xs={4} style={{ marginTop:"30px" }}>
                    {indSkuRelacionado() && (
                      <Button
                        onClick={() => adicionar()}
                        className="filter-dialog-close"
                        color="primary"
                      >
                        Adicionar
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </FormGroup>
            </form>
          </CardContent>
          <CardActions>
            <Button
              onClick={() => closeForm()}
              className="filter-dialog-close"
              color="secondary"
            >
              Cancelar
            </Button>
            {listRelacionados.length > 0 && (
              <Button
              onClick={saveRelation}
              className="filter-dialog-close"
              color="primary"
              >
              {indSelecionado() ? 'Alterar' : 'Salvar'}
            </Button>
              )}
          </CardActions>
        </Card>
        <Card>
          <CardContent>
            {listRelacionados.length > 0 && (
            <TableProductRelation
              rows={listRelacionados}
              columns={columns}
            />
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default ProductGroupingNewForm;



// WEBPACK FOOTER //
// ./src/component/administration/registers/product-grouping-new/ProductGroupingNewForm.tsx